import { createContext, useContext, useState, useCallback } from "react";
import { STRINGS, NEUTRAL, LANGS } from "@/lib/i18n";

const LanguageContext = createContext(null);
const CODES = LANGS.map((l) => l.code);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = localStorage.getItem("lang");
    return CODES.includes(saved) ? saved : "en";
  });

  const change = useCallback((l) => {
    localStorage.setItem("lang", l);
    setLang(l);
  }, []);

  // Merge selected language over English so nothing is ever blank
  const t = { ...STRINGS.en, ...(STRINGS[lang] || {}) };
  const value = { lang, setLang: change, t, N: NEUTRAL, langs: LANGS };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useI18n must be used within LanguageProvider");
  return ctx;
};
